import { FunctionComponent } from 'preact';
import type { Asset } from '@schibsted-svp/svp-api-types';

import { AgeLimitLabel } from '../AgeLimitLabel/AgeLimitLabel';
import { Typography } from '../Typography/Typography';
import { getAssetLabel } from '../../utils/assetLabel';
import { getAssetAgeLimit } from '../../utils/ageLimit';
import { Tag } from '../Tag/Tag';

export interface AssetTitleProps {
  asset: Pick<Asset, 'title' | 'category' | 'series' | 'additional'>;
  shouldRenderAssetLabel?: boolean;
  isSmall?: boolean;
  titleOverride?: string;
}

export const AssetTitle: FunctionComponent<AssetTitleProps> = ({
  asset,
  shouldRenderAssetLabel = true,
  isSmall,
  titleOverride,
}) => {
  const title = titleOverride || asset.title;
  const label = getAssetLabel(asset);
  const ageLimit = getAssetAgeLimit(asset);

  return (
    <div className="vgp-title">
      <Typography
        variant="label"
        size={isSmall ? 'small' : 'medium'}
        color="white"
        title={label}
        className="vgp-title-label"
      >
        {ageLimit !== null && <AgeLimitLabel ageLimit={18} />}
        {shouldRenderAssetLabel && <Tag>{label}</Tag>}
      </Typography>
      <Typography
        title={title}
        variant="body"
        size={isSmall ? 'small' : 'medium'}
        color="subtitle-text"
        bold
      >
        <span className="vgp-title-main">{title}</span>
      </Typography>
    </div>
  );
};
